import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { GridApi, RowNode } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LinkTarget } from '@panaya/ui/p-link';
import { LinkDialogRendererParams } from './link-dialog-renderer.model';

@Component({
    selector: 'entity-link-dialog-renderer',
    template: `
        <div
            *ngIf="!url"
            class="grid-link p-paragraph-2"
            [ngClass]="{ 'p-tpgr-link': node.data && isLinkable(node.data) }"
            [attr.automation-id]="automationId"
            [matTooltip]="value"
            [showOnlyWhenEllipsis]="true"
            [matTooltipClass]="'link-dialog-tooltip'"
            (click)="clickEvent($event, api, node, itemId, linkData)"
        >
            {{ value }}
        </div>
        <a
            *ngIf="url"
            class="grid-link p-paragraph-2 p-tpgr-link "
            [attr.automation-id]="automationId"
            [href]="url | params: urlArgs"
            [target]="target"
            (click)="clickEvent($event, api, node, itemId, linkData)"
        >
            {{ value }}
        </a>
    `,
    styleUrls: ['./link-dialog-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkDialogRendererComponent<TData extends Record<string, number>, IdProp extends keyof TData>
    implements ICellRendererAngularComp
{
    private appId?: number;
    private field?: string;

    public itemId!: number;
    public value = '';
    public automationId = '';
    public api!: GridApi;
    public node!: RowNode<TData>;
    public target: LinkTarget = '_self';
    public url?: string;
    public urlArgs: string[] = [];
    public linkData?: string;
    public tooltip = (data: TData): string => this.value ?? '';
    public clickEvent = (event: Event, api: GridApi, node: RowNode, id: number, linkData?: string): void => void 0;
    public isLinkable = (data: TData): boolean => true;

    public refresh(params: LinkDialogRendererParams<TData, IdProp>): boolean {
        return true;
    }

    agInit(params: LinkDialogRendererParams<TData, IdProp>): void {
        const { getValue, colDef, node, idProp, data, api, target, urlArgs, url, linkData, clickEvent, isLinkable, tooltip } = params;
        this.value = getValue ? getValue() : '';
        this.field = colDef?.field;
        this.appId = node.data?.['appId'];
        this.itemId = idProp ? data[idProp] : parseInt(this.value);
        this.automationId = 'link_dialog_renderer-app_' + this.appId + '-field_' + this.field;
        this.api = api;
        this.node = node;
        this.target = target ?? '_self';
        this.urlArgs = urlArgs ? urlArgs.map((arg) => data[arg].toString()) : [this.value];
        this.url = url;
        this.linkData = linkData;
        this.clickEvent = clickEvent || this.clickEvent;
        this.isLinkable = isLinkable || this.isLinkable;
        this.tooltip = tooltip || this.tooltip;
    }
}
